export const getOverridableConfigValue = ({
  customConfigValue,
  defaultValue = '',
  widgetConfigValue,
}: {
  customConfigValue?: string;
  defaultValue?: string;
  widgetConfigValue?: string | null;
}): string => {
  if (customConfigValue) {
    return String(customConfigValue);
  }

  if (widgetConfigValue) {
    return widgetConfigValue;
  }

  return defaultValue;
};
